import { TestimonialCard } from '@/components/ui/custom';
import { testimonials } from '@/data/mockData';
import { Reveal } from '@/components/system';

export function TestimonialsSection() {
  return (
    <section className="section-y section-glass px-3 sm:px-6">
      <div className="mx-auto w-full min-w-0 max-w-6xl">
        <Reveal>
          <div className="mb-6 text-center sm:mb-8">
            <h2 className="mb-2 px-1 text-2xl font-bold text-foreground sm:text-3xl">
              Histórias reais
            </h2>
            <p className="mx-auto max-w-lg text-sm text-muted-foreground sm:text-base">
              Quem já usou a Kuiva partilha como foi o primeiro passo.
            </p>
          </div>
        </Reveal>

        <div className="grid gap-3 md:grid-cols-2 md:gap-4">
          {testimonials.map((testimonial, index) => (
            <Reveal key={testimonial.id} delayMs={index * 90}>
              <TestimonialCard testimonial={testimonial} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
